import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { cn } from '../../../lib/utils'
import ExercisePlaceholder from './ExercisePlaceholder'

const EQUIPMENT_LABEL_KEY = (e) => `workout.equipment.${e}`

export default function ExerciseCard({ exercise }) {
  const { t } = useTranslation()
  return (
    <Link
      to={`/workout/exercises/${exercise.id}`}
      className={cn(
        'group block rounded-lg border border-border bg-card overflow-hidden',
        'hover:border-app-primary-500/40 hover:shadow-md transition-all'
      )}
    >
      {/* bg-white renders transparent PNGs against a known surface so the
          muscle illustration stays visible against the dark theme. JPGs
          and dark-background PNGs are unaffected — their own pixels
          cover the white. */}
      <div className="aspect-square overflow-hidden bg-white">
        {exercise.photoUrl ? (
          <img
            src={exercise.photoUrl}
            alt={exercise.name}
            loading="lazy"
            className="w-full h-full object-cover"
          />
        ) : (
          <ExercisePlaceholder muscleGroup={exercise.muscle_group} iconClassName="w-12 h-12" />
        )}
      </div>
      <div className="p-2.5">
        <h3 className="text-sm font-medium text-foreground truncate">
          {exercise.name}
        </h3>
        <p className="text-[11px] text-muted-foreground truncate">
          {t(`workout.muscleGroup.${exercise.muscle_group}`)}
          {' · '}
          {t(EQUIPMENT_LABEL_KEY(exercise.equipment_type))}
        </p>
      </div>
    </Link>
  )
}
